
import { AxiosError } from "axios";
import { ref } from "vue";
import { Shinsei } from "@/types/Shinsei";
import { FormUtil } from "@/utils/FormUtil";
import { ShinseiService } from "@/service/ShinseiService";
import { DialogService } from "@/service/DialogService";

export function useCancel() {
  const isCanceling = ref(false);
  const srv = new ShinseiService();

  const cancel = (shinseiId: number): Promise<Shinsei | null> => {
    isCanceling.value = true;
    DialogService.nowloading('申請処理中...');

    let returnval: Shinsei | null;

    return srv.cancel(shinseiId).then(res => {
      if (res !== null) {
        DialogService.info({
          text: `申請を取消しました`
        }, true);
      } else {
        DialogService.error({
          text: '予期せぬ事態が発生し取消に失敗しました'
        }, true);
      }
      isCanceling.value = false;
      returnval = res;
    }).catch(e => {
      const err = e as AxiosError<any>;
      FormUtil.setLaravelError(shinseiId, err);
      returnval = null;
    }).then(() => {
      /* --- finaly処理 --- */
      // 登録中フラグを解除
      isCanceling.value = false;
      return returnval;
    })
  }

  return {
    isCanceling,
    cancel,
  }
}
